export enum ClaimGasStep {
  REVIEW_FORM,
  WAITING_SIGNATURE,
  VALIDATING_TRANSACTION,
  SUCCESS,
  INSUFFICIENT_GAS,
  UNKNOWN_ERROR,
}
